import { createFileRoute, redirect } from '@tanstack/react-router';
import { AGGREGATE_NAMES, USER_ROLES } from 'cpool-constants';
import { schemaSystemVariableResolver_GetBucketConfigurations } from 'cpool-tables/backend-resolvers';

import { authoriseUser } from '~/features/auth/utils/authoriseUser.ts';
import { getQueryOptions } from '~/queryUtils/getQueryOptions.ts';
import { useUserStore } from '~/store/userStore.ts';

const bucketConfigurationsOptions = () => {
    return getQueryOptions({
        aggregateName: AGGREGATE_NAMES.SYSTEM_VARIABLE,
        resolverName: 'getBucketConfigurations',
        schema: schemaSystemVariableResolver_GetBucketConfigurations,
    });
};

export const Route = createFileRoute('/_app/management/bucket/configurations/$bucket')({
    beforeLoad: ({ location }) => {
        authoriseUser([USER_ROLES.corporation_director], location);
        const content = 'ROUTE_TITLE.BUCKETS';
        return {
            meta: [
                {
                    content,
                    name: 'description',
                },
                {
                    content,
                    name: 'title',
                },
            ],
        };
    },
    loader: async ({ context, location }) => {
        const { user } = useUserStore.getState();
        if (!user) {
            throw redirect({ search: { redirect: location.href }, to: '/login' });
        }
        await context.queryClient.ensureQueryData(bucketConfigurationsOptions());
    },
});
